import type { RouteRecord } from 'vite-react-ssg';
import Layout from './Layout';
import Home from './pages/Home';
import ServicePage from './pages/ServicePage';
import About from './pages/About';
import ContactPage from './pages/ContactPage';
import NotFound from './pages/NotFound';
import { SERVICES } from './content/services';

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      {
        path: 'services/:slug',
        element: <ServicePage />,
        getStaticPaths: () => SERVICES.map((s) => `/services/${s.slug}`),
      },
      { path: 'about', element: <About /> },
      { path: 'contact', element: <ContactPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];
